import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "saturation",
    ref: "saturationRef",
    style: _normalizeStyle({ background: _ctx.bgColor }),
    onMousedown: _cache[0] || (_cache[0] = $event => _ctx.handleMouseDown($event))
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "saturation-white" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "saturation-black" }, null, -1)),
    _createElementVNode("div", {
      class: "saturation-pointer",
      style: _normalizeStyle({
        top: _ctx.pointerTop,
        left: _ctx.pointerLeft,
      })
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "saturation-circle" }, null, -1)
    ]), 4)
  ], 36))
}